/**
 * useTutorQueue — loads all tutors via GET /tutors and filters client-side by status.
 *
 * Returns:
 *   tutors      {Array}   tutors matching the current activeStatus filter
 *   allTutors   {Array}   raw unfiltered list (for tab counts)
 *   loading     {boolean}
 *   error       {string|null}
 *   refresh     {()=>void}  re-fetches from the API
 */

import { useState, useEffect, useCallback } from 'react';
import apiService from '../services/apiService';

/**
 * @param {'pending_verification'|'verified'|'suspended'} activeStatus
 */
export function useTutorQueue(activeStatus = 'pending_verification') {
  const [allTutors, setAllTutors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiService.getTutors();
      const list = res?.data ?? res ?? [];
      setAllTutors(Array.isArray(list) ? list : []);
    } catch (err) {
      setError(err?.userMessage || 'Erreur lors du chargement des répétiteurs.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const tutors = allTutors.filter((t) => t.status === activeStatus);

  return { tutors, allTutors, loading, error, refresh: fetchAll };
}
